import moment from 'moment'
import { FORMATS } from 'constants/datetime'

const getDefaultDate = (date: string): string => {
  return moment(date).startOf('d').toISOString()
}

const getDefaultTime = (date: string, increment: number): string | undefined => {
  const start = moment(date)
  const remainder = increment - (start.minute() % increment)
  return moment(start).add(remainder, 'minutes').format(FORMATS.militaryTimeFormat)
}

/**
 * @example getDefaultAppointment() // { date: '2023-02-20T00:00:00.000Z', time: '22:00' }
 */
export const getDefaultAppointment = (
  date: string = moment().toISOString(),
  increment: number = 15
) => ({
  date: getDefaultDate(date),
  time: getDefaultTime(date, increment),
})
